import { useQueryClient } from '@tanstack/react-query';
import SpeedDateCreationForm from './speed-date-creation-form';
import React from 'react';

interface SpeedDateCreationSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

// Error Boundary per catturare errori nel form
class FormErrorBoundary extends React.Component<
  { children: React.ReactNode; onError: () => void },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[SpeedDateCreationSheet] ❌ Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center p-8 text-center">
          <p className="text-white mb-4">Si è verificato un errore nel form.</p>
          <button
            onClick={() => {
              this.setState({ hasError: false });
              this.props.onError();
            }}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg"
          >
            Chiudi e riprova
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function SpeedDateCreationSheet({ isOpen, onClose }: SpeedDateCreationSheetProps) {
  const queryClient = useQueryClient();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Sheet content - full page like travel creation form */}
      <div className="relative flex-1 flex flex-col tg-bg h-full">
        <FormErrorBoundary onError={onClose}>
          <SpeedDateCreationForm
            onClose={onClose}
            onSuccess={() => {
              queryClient.invalidateQueries({ queryKey: ['/api/speed-dates'] });
              onClose();
            }}
          />
        </FormErrorBoundary>
      </div>
    </div>
  );
}
